import { AlertError, AlertSuccess } from 'assets/login';
import toast from 'react-hot-toast';

export const formatTime = (totalSeconds) => {
	const m = Math.floor(totalSeconds / 60)
		.toString()
		.padStart(2, '0');
	const s = (totalSeconds % 60).toString().padStart(2, '0');
	return `${m}:${s}`;
};

export const formatPhoneNumber = (phone) => {
	const digits = phone.replace(/\D/g, '');

	const match = digits.match(/^92(\d{3})(\d{3})(\d{4})$/);

	if (!match) return phone;

	const [, part1, part2, part3] = match;

	return `+92 ${part1}-${part2} ${part3}`;
};

export const successToast = (message) => {
	toast.success(message, {
		icon: <AlertSuccess />,
		style: {
			background: '#0e0e0f',
			border: '1px solid #307e16',
			color: '#307e16',
			fontFamily: 'sans-serif',
			fontSize: '14px'
		},
	});
};

export const errorToast = (message) => {
	toast.error(message, {
		icon: <AlertError />,
		style: {
			background: '#0e0e0f',
			border: '1px solid #b42e2e',
			color: '#b42e2e',
			fontFamily: 'sans-serif',
			fontSize: '14px'
		},
	});
};

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const passwordRegex = /^.{6,}$/;

export const getHighestOrderImageUrl = (images) => {
	if (!images || images.length === 0) {
		return undefined;
	}

	let highest = images[0];

	for (let i = 1; i < images.length; i++) {
		if (images[i].image_order < highest.image_order) {
			highest = images[i];
		}
	}

	return highest.image_url;
};

export const downloadBase64Image = (base64Data, fileName) => {
	const byteString = atob(base64Data.split(',')[1]);
	const mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];

	const ab = new ArrayBuffer(byteString.length);
	const ia = new Uint8Array(ab);

	for (let i = 0; i < byteString.length; i++) {
		ia[i] = byteString.charCodeAt(i);
	}

	const blob = new Blob([ab], { type: mimeString });
	const url = URL.createObjectURL(blob);

	const link = document.createElement('a');
	link.href = url;
	link.download = fileName;
	link.click();

	URL.revokeObjectURL(url);
};
